import React, { useEffect, useState } from "react";
import "./EstatisticasAlunos.css";

const EstatisticasAlunos = () => {
  const [estatisticas, setEstatisticas] = useState(null);
  const [erro, setErro] = useState(null);

  useEffect(() => {
    fetch("/api/estatisticas")
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Erro HTTP! Código: ${response.status} - ${response.statusText}`);
        }
        return response.json();
      })
      .then((data) => setEstatisticas(data))
      .catch((error) => {
        console.error("Erro ao carregar estatísticas:", error);
        setErro(error.message);
      });
  }, []);

  if (erro) {
    return <p className="erro">Erro ao carregar estatísticas: {erro}</p>;
  }

  if (!estatisticas) {
    return <p>Carregando estatísticas...</p>;
  }

  return (
    <div className="estatisticas-container">
      <h2>📊 Estatísticas Gerais</h2>

      <div className="totais-gerais">
        <div className="total-box total-geral">
          <h3>Total de Alunos</h3>
          <p>{estatisticas.totalAlunos}</p>
        </div>
        <div className="total-box total-preregistro">
          <h3>Pré-registro</h3>
          <p>{estatisticas.totalPreRegistro}</p>
        </div>
        <div className="total-box total-ativos">
          <h3>Ativos</h3>
          <p>{estatisticas.totalAtivos}</p>
        </div>
        <div className="total-box total-inativos">
          <h3>Inativos/Desativados</h3>
          <p>{estatisticas.totalInativos}</p>
        </div>
      </div>

      <section className="detalhes-por-classe">
        <h3>Alunos por Classe e Gênero</h3>
        <table>
          <thead>
            <tr>
              <th>Classe</th>
              <th>Meninos</th>
              <th>Meninas</th>
              <th>Total</th>
            </tr>
          </thead>
          <tbody>
            {estatisticas.porClasse.map(({ classe, meninos, meninas }) => (
              <tr key={classe}>
                <td>{classe}</td>
                <td>{meninos}</td>
                <td>{meninas}</td>
                <td>{meninos + meninas}</td>
              </tr>
            ))}
          </tbody>
          <tfoot>
            <tr>
              <td><strong>Total Geral</strong></td>
              <td><strong>{estatisticas.totalMeninos}</strong></td>
              <td><strong>{estatisticas.totalMeninas}</strong></td>
              <td><strong>{estatisticas.totalAlunos}</strong></td>
            </tr>
          </tfoot>
        </table>
      </section>

      <button onClick={() => window.history.back()} className="btn-voltar">🔙 Voltar</button>
    </div>
  );
};

export default EstatisticasAlunos;
